import { render } from "./MonedaList.vue?vue&type=template&id=70145718&scoped=true"
import script from "./MonedaList.vue?vue&type=script&lang=js"
export * from "./MonedaList.vue?vue&type=script&lang=js"

import "./MonedaList.vue?vue&type=style&index=0&id=70145718&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70145718"]])

export default __exports__